type SubscriptionPeriod = {
  start: Date;
  end: Date;
};

export const generateSubscriptionPeriods = (
  startDate: Date,
  expirationDate: Date,
  options?: { currentOnly?: boolean },
): SubscriptionPeriod[] => {
  const periods: SubscriptionPeriod[] = [];
  let currentStart = new Date(startDate);

  while (currentStart < expirationDate) {
    const nextMonth = new Date(currentStart);
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    // Adjust if the next month has fewer days
    if (nextMonth.getDate() !== currentStart.getDate()) {
      nextMonth.setDate(0);
    }

    const periodEnd = nextMonth > expirationDate ? new Date(expirationDate) : nextMonth;
    const period: SubscriptionPeriod = {
      start: new Date(currentStart),
      end: periodEnd,
    };

    if (options?.currentOnly) {
      const now = new Date();
      if (now >= period.start && now < period.end) {
        return [period]; // Return only current period
      }
    } else {
      periods.push(period);
    }

    currentStart = new Date(periodEnd);
  }

  return periods;
};
